import DashBoard from "../pages/DashBoard";
import FourZeroFour from "../components/NotFound/404";

const userRoutes = [
    { path: "/dashboard", component: DashBoard },
    { path: "/404", component: FourZeroFour },
]  

export { userRoutes }